// button-trigger.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ButtonTriggerEvent {
  buttonType: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class ButtonTriggerService {
  private buttonClickSource = new Subject<ButtonTriggerEvent>();
  buttonClick$ = this.buttonClickSource.asObservable();

  triggerButton(buttonType: string, data?: any) {
    this.buttonClickSource.next({ buttonType, data });
  }
}
